
import { useEffect, useMemo, useState } from "react";
import useSelect from "~components/Form/hooks/useSelect";
import { db } from "~/db/db";
import prepareForOptions from "~services/utils/prepareForOptions";
import useTrilha from "./useTrilha";

const useLocal = ({ formikRef, trilha = null }) => {
  const localSelect = useSelect("local");
  const [local, setLocal] = useState(0);

  const [locais, setLocais] = useState([]);
  const [localTrilha, setLocalTrilha] = useState([]);

  const { trilhasObjNome } = useTrilha();

  const fetchLocais = async () => {
    const result = [];
    await db.local.filter((a) => a.ativo).each((item) => result.push(item));
    setLocais(result);
  };

  const fetchLocalTrilha = async () => {
    const localTrilhas = [];
    await db.localTrilha.each((lt) => {
      localTrilhas.push(lt);
    });
    setLocalTrilha(localTrilhas);
  };
  
  useEffect(() => {
    fetchLocais();
    fetchLocalTrilha();
  }, []);

  useEffect(() => {
    if(trilha) {
      fetchLocais();
      fetchLocalTrilha();
    }
  }, [trilha])

  const localTrilhas = useMemo(() => {
    const result = {};
    if (localTrilha?.length) {
      localTrilha.forEach(e => {
        result[`${e.localId}/${e.trilhaId}`] = true;
      });
    }
    return result;
  }, [localTrilha]);

  const optionLocais = useMemo(() => {
    let temp = [];
    if (trilha && Object.entries(trilhasObjNome).length > 0) {
      const trilhaId = trilhasObjNome[trilha]?.id;

      if(trilhaId){
        temp = (locais || []).filter(e => (Object.entries(localTrilhas).length > 0 && localTrilhas[`${e.id}/${trilhaId}`]) && e.ativo)
          .sort((a, b) => a.ordem - b.ordem);

        return prepareForOptions(temp?.length ? temp : locais, ['nome'], 'id');
      }
    } else {
      return prepareForOptions(locais, "nome", 'id');
    }
  }, [locais, trilha, localTrilhas, trilhasObjNome]);

  function onChangeLocal(e) {
    localSelect.upDateValue(e.value);
    localSelect.upDateDefaultValue(e || "");
    formikRef?.current?.setFieldValue("localId", e.value);
    setTimeout(() => formikRef?.current?.setFieldTouched("localId", true));
    setLocal(e.value);
  }

  function SetSelectLocal(id) {
    const selectedLocal = (optionLocais || []).find((l) => l.value == id);
    if (selectedLocal)
      onChangeLocal(selectedLocal);
  }

  return {
    locais,
    optionLocais,
    onChangeLocal,
    SetSelectLocal,
    local,
    localSelect
  };
}

export default useLocal;